// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepper-wrapper {
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    color:#000;
}

.stepper-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;

    @media (max-width: 768px) {
        font-size: 12px;
    }
}

.stepper-item::before {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 20px;
    left: -50%;
    z-index: 2;
}

.stepper-item::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 20px;
    left: 50%;
    z-index: 2;
}

.stepper-item .step-counter {
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #ccc;
    margin-bottom: 6px;
}

.stepper-item.active {
    font-weight: bold;
}

.stepper-item.completed .step-counter {
    background-color: #125ed8;
    color:#fff;
}

.stepper-item.completed::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #125ed8;
    width: 100%;
    top: 20px;
    left: 50%;
    z-index: 3;
}

.stepper-item:first-child::before {
    content: none;
}

.stepper-item:last-child::after {
    content: none;
}

#dob input[type="date"]::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    width: auto;
}
.rct-node-icon {
    display: none;
}
.rct-option .rct-option-expand-all{
    display: none;
}
ol li{
    list-style: none;
}
.rct-collapse .rct-collapse-btn{
    display: none;
}
button.rct-collapse.rct-collapse-btn{
    display: none;
}

.controls {
    position: absolute;
    bottom: 20px;
    left: 50%;
    width: 50%;
    transform: translateX(-50%);
    height: 40px;
    display: flex;
    align-items: center;
  }
  
  .slider {
    padding: 22px 0px;
  }
  
  .zoom-range {
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 2px;
    border-top: 5px solid #b5b2b2;
    border-bottom: 5px solid #b5b2b2;
    background: #3f51b5;
    width: 100%;
  }
  
  .zoom-range::-moz-range-thumb {
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid #3f51b5;
    background: #3f51b5;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
  
  .zoom-range::-webkit-slider-thumb {
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid #3f51b5;
    background: #3f51b5;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
  
  .controls:hover input[type='range']::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px 8px rgba(63, 81, 181, 0.16);
    border-radius: 50%;
  }
  
  .controls:hover input[type='range']::-moz-range-thumb {
    box-shadow: 0px 0px 0px 8px rgba(63, 81, 181, 0.16);
  }
  .jconfirm .jconfirm-box.jconfirm-type-blue {
    border-top: solid 7px #0076FF !important;
    animation-name: unset !important;
  }`, "",{"version":3,"sources":["webpack://./src/assets/css/style_ashish.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,OAAO;;IAEP;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,WAAW;IACX,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,WAAW;IACX,SAAS;IACT,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,WAAW;IACX,SAAS;IACT,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,MAAM;IACN,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,6BAA6B;IAC7B,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,6DAA6D;EAC/D;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,6DAA6D;EAC/D;;EAEA;IACE,mDAAmD;IACnD,kBAAkB;EACpB;;EAEA;IACE,mDAAmD;EACrD;EACA;IACE,wCAAwC;IACxC,gCAAgC;EAClC","sourcesContent":[".stepper-wrapper {\n    margin-top: auto;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    color:#000;\n}\n\n.stepper-item {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1;\n\n    @media (max-width: 768px) {\n        font-size: 12px;\n    }\n}\n\n.stepper-item::before {\n    position: absolute;\n    content: \"\";\n    border-bottom: 2px solid #ccc;\n    width: 100%;\n    top: 20px;\n    left: -50%;\n    z-index: 2;\n}\n\n.stepper-item::after {\n    position: absolute;\n    content: \"\";\n    border-bottom: 2px solid #ccc;\n    width: 100%;\n    top: 20px;\n    left: 50%;\n    z-index: 2;\n}\n\n.stepper-item .step-counter {\n    position: relative;\n    z-index: 5;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: #ccc;\n    margin-bottom: 6px;\n}\n\n.stepper-item.active {\n    font-weight: bold;\n}\n\n.stepper-item.completed .step-counter {\n    background-color: #125ed8;\n    color:#fff;\n}\n\n.stepper-item.completed::after {\n    position: absolute;\n    content: \"\";\n    border-bottom: 2px solid #125ed8;\n    width: 100%;\n    top: 20px;\n    left: 50%;\n    z-index: 3;\n}\n\n.stepper-item:first-child::before {\n    content: none;\n}\n\n.stepper-item:last-child::after {\n    content: none;\n}\n\n#dob input[type=\"date\"]::-webkit-calendar-picker-indicator {\n    background-position: right;\n    background-size: auto;\n    cursor: pointer;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n    width: auto;\n}\n.rct-node-icon {\n    display: none;\n}\n.rct-option .rct-option-expand-all{\n    display: none;\n}\nol li{\n    list-style: none;\n}\n.rct-collapse .rct-collapse-btn{\n    display: none;\n}\nbutton.rct-collapse.rct-collapse-btn{\n    display: none;\n}\n\n.controls {\n    position: absolute;\n    bottom: 20px;\n    left: 50%;\n    width: 50%;\n    transform: translateX(-50%);\n    height: 40px;\n    display: flex;\n    align-items: center;\n  }\n  \n  .slider {\n    padding: 22px 0px;\n  }\n  \n  .zoom-range {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    height: 2px;\n    border-top: 5px solid #b5b2b2;\n    border-bottom: 5px solid #b5b2b2;\n    background: #3f51b5;\n    width: 100%;\n  }\n  \n  .zoom-range::-moz-range-thumb {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    border: 1px solid #3f51b5;\n    background: #3f51b5;\n    border-radius: 50%;\n    width: 12px;\n    height: 12px;\n    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  }\n  \n  .zoom-range::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    border: 1px solid #3f51b5;\n    background: #3f51b5;\n    border-radius: 50%;\n    width: 12px;\n    height: 12px;\n    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  }\n  \n  .controls:hover input[type='range']::-webkit-slider-thumb {\n    box-shadow: 0px 0px 0px 8px rgba(63, 81, 181, 0.16);\n    border-radius: 50%;\n  }\n  \n  .controls:hover input[type='range']::-moz-range-thumb {\n    box-shadow: 0px 0px 0px 8px rgba(63, 81, 181, 0.16);\n  }\n  .jconfirm .jconfirm-box.jconfirm-type-blue {\n    border-top: solid 7px #0076FF !important;\n    animation-name: unset !important;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
